import { useState } from "react";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";

import { useAuth } from "context/AuthContext";
import { routesPath } from "conts/routes";
import { FiltersModal } from "ui/base/modal/FiltersModal";
import { FiltersSection } from "ui/blocks/filtersSection/FiltersSection";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { pixelTrackEvent } from "utils/facebookPixel";
import { MobileFiltersSection } from "../../filtersSection/mobileFilterSection";
import SearchBar from "./SearchBar";

export const HeaderNavigation = ({primary, mobile}) => {
    const {userRole} = useAuth();
    const {pathname} = useLocation();
    const [open, setOpen] = useState(false);

    const isAdmin = userRole === 1;
    const showFilterPage =
        pathname.startsWith("/user") ||
        pathname.includes("policies") ||
        pathname.startsWith("/faq");

    const showFilter = isAdmin && showFilterPage;

    return mobile && pathname !== '/'
        ? <div><MobileFiltersSection isCompact/></div>
        : (
            <Navigation primary={primary} open={open} showFilter={showFilter}>
                {showFilter ? (
                    <>
                        <div className="filter-trigger" onClick={() => setOpen(true)}>
                            <SearchBar/>
                        </div>

                        <FiltersModal show={open} handleClose={() => setOpen(false)}>
                            <FiltersSection hasSeparator={false} onSearch={() => setOpen(false)}/>
                        </FiltersModal>
                    </>
                ) : (
                    <HashLink
                        to={`${routesPath.main}#download`}
                        onClick={() =>
                            pathname === routesPath.main &&
                            pixelTrackEvent("Home-header: Clicked on Download")
                        }
                    >
                        Download
                    </HashLink>
                )}
            </Navigation>
        );
};

const Navigation = styled.div`
    display: none;
    max-width: 660px;
    width: 100%;
    gap: 1rem;
    font-size: ${fonts.sizes.small};
    font-family: Poppins;
    font-weight: 400;
    color: ${({primary}) =>
            primary ? defaultThemeColors.white : defaultThemeColors.txt};
    transition: color 0.2s;
    margin: 0 calc(-10%);
    z-index: 0;

    @media (width >= ${mediaSizes.lg}) {
        display: ${({showFilter}) => (showFilter ? "flex" : "none")};
        justify-content: center;
        align-items: center;
    }

    .filter-trigger {
        width: 100%;
        opacity: ${({open}) => (open ? 0 : 1)};
        visibility: ${({open}) => (open ? "hidden" : "visible")};
        transition: opacity 0.3s ease, visibility 0.3s ease;
        cursor: pointer;

        & * {
            pointer-events: none;
        }
    }
`;

const MobileSearch = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${defaultThemeColors.white};
    border-radius: 999px;
    box-shadow: 0 4px 12px rgba(13, 11, 134, 0.08);
    padding: 0.4rem 0.9rem;
    cursor: pointer;
    width: 100%;
    max-width: 220px;
    height: 36px;
    transition: all 0.2s ease-in-out;

    span {
        margin-left: 0.4rem;
        font-size: 0.95rem;
        color: rgba(0, 0, 0, 0.55);
    }

    svg {
        color: ${defaultThemeColors.txt};
    }

    &:active {
        box-shadow: 0 0 0 2px rgba(13, 11, 134, 0.15);
        transform: scale(0.98);
    }

    @media (min-width: ${mediaSizes.lg}) {
        display: none;
    }
`;
